/**
 * Public website identity and URL helpers.
 *
 * VITE_PUBLIC_SITE_URL is intentionally an explicit override so preview and
 * local builds can provide their own public origin. Production falls back to
 * the canonical Park Model Prices host when the variable is not configured.
 */
const DEFAULT_PUBLIC_SITE_URL = 'https://www.parkmodelprices.com'
const configuredPublicSiteUrl = import.meta.env?.VITE_PUBLIC_SITE_URL

function normalizeOrigin(value) {
  const candidate = String(value || '').trim()
  if (!candidate) return DEFAULT_PUBLIC_SITE_URL

  return candidate.replace(/\/+$/, '')
}

export const PUBLIC_SITE_URL = normalizeOrigin(configuredPublicSiteUrl)
export const PUBLIC_SITE_NAME = 'Park Model Prices'
export const LEGAL_ORGANIZATION_NAME = 'Firefly Tiny Homes'
export const PUBLIC_SITE_LOGO_PATH = '/logo/firefly-logo.png'

/**
 * Build an absolute URL for a public site path while preserving external
 * URLs passed by content editors (for example, a remote article image).
 */
export function publicUrl(path = '') {
  const value = String(path || '').trim()
  if (!value) return PUBLIC_SITE_URL
  if (/^[a-z][a-z\d+.-]*:\/\//i.test(value)) return value

  return `${PUBLIC_SITE_URL}/${value.replace(/^\/+/, '')}`
}
